import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { colors } from "colors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { editorActions } from "store/editor";
import CodeIcon from "@mui/icons-material/Code";
import { MARKDOWN_DOC_TYPE } from "schemas/documents";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { useNavigate, useParams } from "react-router-dom";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import EditDocumentModal from "components/react-lib/generic-ui/modals/EditDocumentModal";

export default function DocumentList() {


  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const navigate = useNavigate();
  const params = useParams();

  const activeDocumentId = params.documentId;
  
  const dispatch = useDispatch();

  const q = uid ? (
    query(
      collection(db, "documents"),
      where("uid", "==", uid),
    )
  ) : null;


  const [documentsSnap, loading, error] = useCollection(q);
  
  if(error) {
    console.log(error);
  }

  const changeActiveDocument = (documentToOpen) => {
    navigate(`/docs/${documentToOpen.id}`);
  };

  const renderDocuments = () => {
    const documents = snapshotToArray(documentsSnap).sort((x, y) => -(x.createdAt - y.createdAt));
    if (!documents || documents.length === 0) {
      return (
        <ListItem>
          <ListItemText
            sx={{
              color: colors.white,
            }}
          >
            No documents.
          </ListItemText>
        </ListItem>
      );
    }
    return documents.map((document, index) => {
      return (
        <ListItem
          key={document.id}
          // secondaryAction={
          //   <DocumentMenu
          //     previous={index === 0 ? null : documents[index - 1]}
          //     next={index + 1 >= documents.length ? null : documents[index + 1]}
          //     document={document}
          //     color="white"
          //   />
          // }
          sx={{
            borderRadius: "4px",
            backgroundColor:
              document.id === activeDocumentId ? colors.drakGray : colors.black,
          }}
        >
          {/* <ListItemIcon>
            {document.type === MARKDOWN_DOC_TYPE ? (
              <TextSnippetIcon />
            ) : (
              <CodeIcon />
            )}
          </ListItemIcon> */}
          <ListItemButton onClick={() => changeActiveDocument(document)}>
            <ListItemText
              sx={{
                color: colors.white,
              }}
              primary={<Typography>{document.name}</Typography>}
              secondary={
                <Typography variant="caption">
                  {new Date(document.createdAt).toLocaleString()}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      );
    });
  };

  return (
    <List dense disablePadding>
      {loading ? (
        <>
          {Array.from(Array(3)).map((x, index) => (
            <ListItem key={`document-skeleton-${index}`}>
              <ListItemText
                primary={
                  <Skeleton variant="text" sx={{ bgcolor: colors.drakGray }} />
                }
                secondary={
                  <Skeleton variant="text" sx={{ bgcolor: colors.drakGray }} />
                }
              />
            </ListItem>
          ))}
        </>
      ) : (
        renderDocuments()
      )}
    </List>
  );
}
